import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { LicenseProps } from "./types";

import "./styles.scss";

export const License: FC<LicenseProps> = ({
  totalLicense,
  availableLicense,
}) => {
  const { t } = useTranslation();

  return (
    <div className="ams-license">
      {t("licensesAvailable", {
        licenses: totalLicense,
        available: availableLicense,
      })}
    </div>
  );
};
